import { render } from "./loading-container.vue?vue&type=template&id=4a9f0e94&scoped=true&lang=html"
import script from "./loading-container.vue?vue&type=script&lang=js"
export * from "./loading-container.vue?vue&type=script&lang=js"

import "./loading-container.vue?vue&type=style&index=0&id=4a9f0e94&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\unistroy\\market\\market-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9f0e94"]])

export default __exports__